/**
 * Display vocabulary for the sampling queue.
 *
 * Money and date helpers are re-exported from the order book rather than
 * duplicated — the two screens are the same table style and must not drift.
 */
import type { StatusTone } from "@flint/ui";

export { orderMoney as sampleMoney, exactMoney, shortDate } from "../orders/order-format.ts";

/**
 * What the badge says. These are **phases**: `overdue` is not a stored status,
 * it's a `dispatched`/`delivered` row past its return date.
 */
export const SAMPLE_PHASE_LABEL = {
  requested: "Requested",
  dispatched: "Dispatched",
  delivered: "Delivered",
  converted: "Converted",
  returned: "Returned",
  overdue: "Overdue",
} as const;

/**
 * Requested is muted (nothing has happened yet), dispatched/delivered are
 * informational, converted green (it became business), returned neutral-good
 * (the goods are home), overdue red — the only one that needs acting on today.
 */
export const SAMPLE_PHASE_TONE = {
  requested: "muted",
  dispatched: "sky",
  delivered: "sky",
  converted: "ok",
  returned: "muted",
  overdue: "bad",
} as const satisfies Record<string, StatusTone>;

export type SamplePhase = keyof typeof SAMPLE_PHASE_LABEL;

export const SAMPLE_PURPOSE_LABEL = {
  evaluation: "Evaluation",
  photoshoot: "Photoshoot",
  trade_show: "Trade show",
} as const;
